import { useState } from "react";
import { subscribe } from "../../services/api";
import "./Newsletter.css";

export default function Newsletter() {
  const [email, setEmail]     = useState("");
  const [msg, setMsg]         = useState({ text: "", type: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setMsg({ text: "", type: "" });

    try {
      const res = await subscribe(email.trim());
      setMsg({ text: res.message || "Subscribed!", type: "success" });
      setEmail("");
    } catch (err) {
      const detail = err.response?.data?.message || "Something went wrong";
      setMsg({ text: detail, type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="newsletter-section">
      <div className="newsletter-box reveal">
        {/* left text */}
        <div className="newsletter-text">
          <h3>Connect with us</h3>
          <p>
            Subscribe to receive the latest news and updates about iGamesTech.
            We promise not to spam you!
          </p>
        </div>

        {/* right form */}
        <div className="newsletter-right">
          <div className="newsletter-form">
            <input
              type="email"
              placeholder="Enter email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
            />
            <button className="btn-continue" onClick={handleSubmit} disabled={loading}>
              {loading ? "Wait…" : "Continue"}
            </button>
          </div>
          <div className={`newsletter-msg ${msg.type}`}>{msg.text}</div>
        </div>
      </div>
    </section>
  );
}
